import { Controller } from 'stimulus';
import { h, render, Component } from 'preact';

class ReMountController extends Controller {
  static values = {
    componentName: String,
    props: Object
  };

  async connect() {
    const componentClass = await require('../components/' + this.componentNameValue + '.jsx').default;
    render(h(componentClass, this.propsValue), this.element.parentElement, this.element);
  }
}

export default ReMountController;
